import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import Dialog from "../../common/dialog";
import ManaButton from "../../common/ManaButton";
import ImageComponent from "../../common/ImageComponent";
import AppTheme from "../../AppTheme";

export default function RoutineConfirmDialog({
  routine,
  close = () => {},
  applyRoutine,
  saveRoutine,
}) {
  return (
    <Dialog.Container
      onClose={close}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        paddingTop: 0,
        marginTop: 0,
        paddingBottom: 20,
        paddingHorizontal: 21,
      }}
    >
      <View style={styles.header}>
        <Text style={styles.title}>Routine Applied.</Text>
        <Text style={styles.description}>
          You’ve applied a modified version of the routine:
        </Text>

        <View
          style={{ alignItems: "center", flexDirection: "row", height: 40 }}
        >
          {routine.icon ? (
            <ImageComponent
              styles={styles.icon}
              icon={routine && routine.icon}
            />
          ) : null}

          <Text style={styles.name}>{routine.name}</Text>
        </View>
      </View>

      <View style={styles.buttons}>
        <ManaButton
          style={[styles.button]}
          styleText={styles.buttonText}
          text="Replace Existing Routine"
          onPress={() => saveRoutine(routine)}
        />

        <ManaButton
          isMainButton
          style={[styles.button]}
          styleText={styles.buttonText}
          text={`Apply once Without Saving`}
          onPress={() => applyRoutine(routine)}
        />
      </View>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  close: {
    position: "absolute",
    top: 5,
    right: 5,
  },
  title: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginTop: 10,
  },
  buttons: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 286,
    height: 40,
    marginBottom: 8,
  },
  buttonText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: 6,
  },
  name: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  description: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
});
